import { Component, Input, HostBinding } from '@angular/core';
import { FilterColumn as FilterOptions } from './model';
import { CommonModule } from '@angular/common';
import { IconDirective } from '@seech/shared-ng';
import { ButtonDirective, FilterTriggerDirective } from '../../directives';
import { DateComponent } from '../date/date.component';

@Component({
  selector: 'seech-filter',
  templateUrl: './filter-sort.component.html',
  styleUrls: ['./filter-sort.component.scss'],
  standalone: true,
  imports: [
    CommonModule,
    IconDirective,
    ButtonDirective,
    FilterTriggerDirective,
    DateComponent,
  ],
})
export class FilterSortComponent {
  @HostBinding('style.width') width = '100%';
  @HostBinding('style.display') display = 'block';
  @Input({ required: true }) options: FilterOptions[] = [];
  @Input() searchDebounceTime = 500;
  @Input() showSort = true;
  @Input() showFilter = true;
  @Input() showLabel = true;
}
